namespace pixi_ui.component {
    export class Transparency implements IComponent {
        public alpha: number;

        constructor(alpha: number) {
            this.alpha = alpha;
        }

        public attach(element: Element): void {
            element.alpha = this.alpha;
        }

        public detach(element: Element): void {
            element.alpha = 1;
        }

        public resize(element: Element): void {}
    }
}
